import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import PatientDetails from "./pages/PatientDetails";
import NewVisit from "./pages/NewVisit";
import AddPatient from "./pages/AddPatient";
import EditVisit from "./pages/EditVisit";
import Login from "./pages/Login";
import BottomNav from "./components/BottomNav";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";

function Layout() {
  const location = useLocation();
  const hideNav = location.pathname === "/login";

  return (
    <>
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />

        <Route
          path="/patients/new"
          element={
            <ProtectedRoute>
              <AddPatient />
            </ProtectedRoute>
          }
        />

        <Route
          path="/patients/:id"
          element={
            <ProtectedRoute>
              <PatientDetails />
            </ProtectedRoute>
          }
        />

        <Route
          path="/patients/:id/visit/new"
          element={
            <ProtectedRoute>
              <NewVisit />
            </ProtectedRoute>
          }
        />

        <Route
          path="/visits/:visitId/edit"
          element={
            <ProtectedRoute>
              <EditVisit />
            </ProtectedRoute>
          }
        />
      </Routes>

      {!hideNav && <BottomNav />}
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Layout />
      </AuthProvider>
    </BrowserRouter>
  );
}
